import { logger } from '../../../utils/logger'
import { removeSessionItem } from '../../../utils/session-storage'
import type { ServiceHandler } from './service-registry'
import { getSessionStorageMetadataKey } from './setMetadata'
import type {
  ClearMetadataRequest,
  ClearMetadataResponse,
} from '@custom-embedded-code-sdk/methods/metadata'

/**
 * CLEAR_METADATA service handler
 *
 * Handles requests to clear metadata for the current campaign from session storage.
 * The session storage key is `metadata_{campaignId}`.
 */
export const clearMetadata: ServiceHandler<ClearMetadataRequest, ClearMetadataResponse> = async ({
  iframeId,
  messageId,
  sendSuccessResponse,
  sendErrorResponse,
  pageConfig,
}) => {
  const campaignId = pageConfig.campaignId

  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:clearMetadata: Campaign ID not available')
    }

    const storageKey = getSessionStorageMetadataKey(campaignId)
    removeSessionItem(storageKey)

    logger('info', 'CustomEmbeddedCode:clearMetadata: Metadata successfully cleared', {
      context: { iframeId, messageId, campaignId, storageKey },
    })

    sendSuccessResponse(iframeId, messageId, { success: true })
  } catch (error) {
    logger(
      'error',
      new Error('CustomEmbeddedCode:clearMetadata: Failed to clear metadata', { cause: error }),
      {
        context: { iframeId, messageId, campaignId },
      },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to clear metadata')
  }
}
